import { Button, Grid, GridColumn, Text } from 'telia-front-react';
import { inject, observer } from 'mobx-react';
import * as React from 'react';

import AnalyticsService from '../../../services/AnalyticsService';
import { IPreviousInvoicesFilterStore } from '../../../stores/PreviousInvoicesFilterStore';
import { ITranslateStore } from '../../../stores/TranslateStore';
import FilterDateField from '../FilterDateField';

interface IPreviousInvoicesProps {
  previousInvoicesFilterStore?: IPreviousInvoicesFilterStore;
  translateStore?: ITranslateStore;
  analyticsService?: AnalyticsService;
}

@inject('previousInvoicesFilterStore', 'translateStore', 'analyticsService')
@observer
export default class PreviousInvoicesFilter extends React.Component<IPreviousInvoicesProps> {
  public render(): React.ReactNode {
    const translate = this.props.translateStore.translate;
    const store = this.props.previousInvoicesFilterStore;
    const analyticsService = this.props.analyticsService;

    return (
      <Text>
        <h3 className="h4">{translate('invoices.previous-invoices.filter.title')}</h3>
        <Grid align={['bottom-xs']}>
          <GridColumn width={['lg-3', 'md-3', 'sm-6']}>
            <FilterDateField
              id="previous-invoices-filter-from-date-id"
              label={translate('invoices.previous-invoices.filter.from')}
              date={store.fromDate}
              onChange={store.setFromDate}
            />
          </GridColumn>
          <GridColumn width={['lg-3', 'md-3', 'sm-6']}>
            <FilterDateField
              id="previous-invoices-filter-to-date-id"
              label={translate('invoices.previous-invoices.filter.to')}
              date={store.toDate}
              onChange={store.setToDate}
            />
          </GridColumn>
          <GridColumn width={['lg-3', 'md-3', 'sm-6']}>
            <Button
              text={translate('invoices.previous-invoices.filter.apply')}
              onClick={() => {
                store.applyFilter();
                analyticsService.previousInvoicesApplyFilter();
              }}
            />
          </GridColumn>
        </Grid>
      </Text>
    );
  }
}
